import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { _SearchStudents } from "../../models/studentModel";
import PsTextSearchBox from "../../utils/PsTextSearchBox";

const StudentSearch = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [dataList, setDataList] = useState([]);

  const GetStudents = (value) => {
    setDataList([]);
    _SearchStudents({ student_name: value }).then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      } else {
      }
    });
    setLoader(false);
  };

  return (
    <>
      <Header backAction={true} title="Student Search" rightActions={[]} />
      <div className="container-sm">
        <Card>
          <Card.Header className="card-header-bg text-uppercase fw-bold">
            Search by Admission No, Register No, Name
          </Card.Header>
          <Card.Body>
            <PsTextSearchBox
              placeholder="Search by admn no, reg no, name"
              onSuccess={(e) => GetStudents(e)}
            />
            {dataList.map((item) => (
              <Card
                className="my-1 hover"
                style={{ border: "1px solid black" }}
              >
                <Row>
                  <Col md={8} sm={8} xs={8}>
                    <div className="text-uppercase fw-bold">
                      {item.name} {item.initial}
                    </div>
                    <div>{item.registerno}</div>
                  </Col>
                  <Col
                    md={4}
                    sm={4}
                    xs={4}
                    className="text-end align-content-center"
                  >
                    <Button size="sm" className="bg-theme">
                      view
                    </Button>
                  </Col>
                </Row>
              </Card>
            ))}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
export default StudentSearch;
